import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export const getOperatorTabNavigationProps = carrierData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
    mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id,
    requestParams: {
      carrier: rowInfo.row['cardit.postalOperator'],
      carriers: carrierData.carriers,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.RESDIT_74_21_PERFORMANCE_DETAILS_802.id,
    ],
  } : {}
);

export default (data, carrierData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new TextColumn('Postal operator', 'cardit.postalOperator').withTotalHeader('Total', 'bg-total-grey'),
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'cardit.total').withTotalHeader(sumTotal, 'bg-total-grey'), getOperatorTabNavigationProps(carrierData)),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_LOCATION_802.id,
        mainReportId: ReportDefinitions.RESDIT_74_21_PERFORMANCE_OPERATOR_802.id,
        requestParams: {
          isTotal: true,
          carrier: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
    {
      Header: 'RESDIT',
      columns: [
        new NonZeroNumberColumn('74', 'resdit.resdit74').withTotalHeader(sumTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('21', 'resdit.resdit21').withTotalHeader(sumTotal, 'bg-total-grey'),
      ],
    },
  ];
};
